// extracted by mini-css-extract-plugin
export default {"bodyClassName":"ConfirmModal-module_bodyClassName__nfLwS9"};